const mauritius = {
  "title": "Mauritius",
  "version": "1.1.2",
  "type": "FeatureCollection",
  "copyright": "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth",
  "copyrightShort": "Natural Earth",
  "copyrightUrl": "http://www.naturalearthdata.com",
  "crs": {
    "type": "name",
    "properties": {
      "name": "urn:ogc:def:crs:EPSG:3337"
    }
  },
  "hc-transform": {
    "default": {
      "crs": "+proj=lcc +lat_1=-20.19506944444445 +lat_0=-20.19506944444445 +lon_0=57.52182777777778 +k_0=1 +x_0=1000000 +y_0=1000000 +ellps=clrk80 +towgs84=-770.1,158.4,-498.2,0,0,0,0 +units=m +no_defs",
      "scale": 0.0117548377066,
      "jsonres": 15.5,
      "jsonmarginX": -999,
      "jsonmarginY": 9851.0,
      "xoffset": 976478.269669,
      "yoffset": 1024209.03368
    }
  },
  "features": [{
    "type": "Feature",
    "id": "MU.6684",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.43,
      "hc-middle-y": 0.52,
      "hc-key": "mu-6684",
      "hc-a2": "GP",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "2346230",
      "subregion": "Grand Port",
      "fips": null,
      "postal-code": null,
      "name": "Grand Port",
      "country": "Mauritius",
      "type-en": "District",
      "region": null,
      "longitude": "57.6498",
      "woe-name": "Grand Port",
      "latitude": "-20.392",
      "woe-label": "Grand Port, MU, Mauritius",
      "type": "District"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [8031, 3285],
          [7987, 2970],
          [8093, 2661],
          [7629, 2507],
          [7099, 2093],
          [6775, 1619],
          [6921, 1285],
          [6935, 1143],
          [7037, 970],
          [7051, 860],
          [6984, 675],
          [6876, 637],
          [6755, 644],
          [6651, 585],
          [6395, 125],
          [6250, -78],
          [6011, -240],
          [5227, -489],
          [5184, -264],
          [5123, 191],
          [4879, 862],
          [4532, 1253],
          [4144, 1339],
          [3613, 1318],
          [4634, 2509],
          [5288, 2487],
          [5717, 2616],
          [5942, 2811],
          [6330, 2832],
          [7066, 2897],
          [7618, 3329],
          [8031, 3285]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6682",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.58,
      "hc-middle-y": 0.50,
      "hc-key": "mu-6682",
      "hc-a2": "MO",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "2346231",
      "subregion": "Moka",
      "fips": null,
      "postal-code": null,
      "name": "Moka",
      "country": "Mauritius",
      "type-en": "District",
      "region": null,
      "longitude": "57.5955",
      "woe-name": "Moka",
      "latitude": "-20.2492",
      "woe-label": "Moka, MU, Mauritius",
      "type": "District"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5942, 2811],
          [5717, 2616],
          [5288, 2487],
          [4634, 2509],
          [4226, 2791],
          [4042, 3137],
          [4124, 3397],
          [3797, 3830],
          [3613, 4090],
          [3245, 4134],
          [2795, 4545],
          [2530, 5217],
          [2468, 5585],
          [2836, 5715],
          [3082, 5607],
          [3470, 5412],
          [3618, 5363],
          [3797, 5303],
          [4125, 5433],
          [4513, 5693],
          [4792, 5707],
          [4779, 5628],
          [5168, 5454],
          [5821, 4956],
          [5208, 4350],
          [6147, 3569],
          [5942, 2811]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6679",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.49,
      "hc-middle-y": 0.39,
      "hc-key": "mu-6679",
      "hc-a2": "PA",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "2346232",
      "subregion": "Pamplemousses",
      "fips": null,
      "postal-code": null,
      "name": "Pamplemousses",
      "country": "Mauritius",
      "type-en": "District",
      "region": null,
      "longitude": "57.573",
      "woe-name": "Pamplemousses",
      "latitude": "-20.0899",
      "woe-label": "Pamplemousses, MU, Mauritius",
      "type": "District"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [4792, 5707],
          [4513, 5693],
          [4125, 5433],
          [3797, 5303],
          [3618, 5363],
          [3695, 5888],
          [3634, 6711],
          [3491, 6971],
          [3143, 6885],
          [2723, 6952],
          [2619, 6969],
          [2632, 7345],
          [2920, 7875],
          [3156, 8597],
          [3272, 8814],
          [3356, 8935],
          [3882, 9359],
          [4012, 9418],
          [4268, 9438],
          [4842, 8747],
          [4883, 8487],
          [4760, 8206],
          [5312, 7642],
          [5005, 7274],
          [5229, 6299],
          [5147, 6104],
          [4820, 5888],
          [4792, 5707]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6683",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.47,
      "hc-middle-y": 0.75,
      "hc-key": "mu-6683",
      "hc-a2": "PW",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "2346233",
      "subregion": "Plaines Wilhems",
      "fips": null,
      "postal-code": null,
      "name": "Plaines Wilhems",
      "country": "Mauritius",
      "type-en": "District",
      "region": null,
      "longitude": "57.5197",
      "woe-name": "Plaines Wilhems",
      "latitude": "-20.3599",
      "woe-label": "Plaines Wilhems, MU, Mauritius",
      "type": "District"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2468, 5585],
          [2530, 5217],
          [2795, 4545],
          [3245, 4134],
          [3613, 4090],
          [3797, 3830],
          [4124, 3397],
          [4042, 3137],
          [4226, 2791],
          [4634, 2509],
          [3613, 1318],
          [3409, 1274],
          [3245, 1404],
          [2959, 1448],
          [2918, 1274],
          [2796, 863],
          [2490, 906],
          [2510, 1209],
          [2326, 1318],
          [1958, 1404],
          [1795, 1621],
          [1979, 1772],
          [1856, 2097],
          [1754, 2509],
          [1876, 2639],
          [2142, 2639],
          [2224, 2769],
          [2187, 2804],
          [2416, 2940],
          [2806, 2439],
          [3775, 2852],
          [3697, 3089],
          [3285, 3455],
          [2950, 3857],
          [2638, 4424],
          [2415, 5014],
          [1970, 5018],
          [2013, 5333],
          [2182, 5628],
          [2468, 5585]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6691",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.51,
      "hc-middle-y": 0.53,
      "hc-key": "mu-6691",
      "hc-a2": "CU",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "1377308",
      "subregion": "Plaines Wilhems",
      "fips": null,
      "postal-code": null,
      "name": "Curepipe",
      "country": "Mauritius",
      "type-en": "City",
      "region": null,
      "longitude": "57.5168",
      "woe-name": "Curepipe (2)",
      "latitude": "-20.3183",
      "woe-label": null,
      "type": "City"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3285, 3455],
          [3697, 3089],
          [3775, 2852],
          [2806, 2439],
          [2416, 2940],
          [3285, 3455]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6690",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.41,
      "hc-middle-y": 0.43,
      "hc-key": "mu-6690",
      "hc-a2": "BB",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "1377240",
      "subregion": "Plaines Wilhems",
      "fips": null,
      "postal-code": null,
      "name": "Beau Bassin-Rose Hill",
      "country": "Mauritius",
      "type-en": "City",
      "region": null,
      "longitude": "57.4713",
      "woe-name": "Beau Bassin",
      "latitude": "-20.2387",
      "woe-label": null,
      "type": "City"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1970, 5018],
          [2415, 5014],
          [2638, 4424],
          [1918, 4271],
          [1902, 4530],
          [1970, 5018]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.90",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.77,
      "hc-middle-y": 0.50,
      "hc-key": "mu-90",
      "hc-a2": "PL",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "2346234",
      "subregion": "Port Louis",
      "fips": null,
      "postal-code": null,
      "name": "Port Louis",
      "country": "Mauritius",
      "type-en": "City",
      "region": null,
      "longitude": "57.5296",
      "woe-name": "Port Louis",
      "latitude": "-20.1667",
      "woe-label": "Port Louis, MU, Mauritius",
      "type": "City"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3618, 5363],
          [3470, 5412],
          [3082, 5607],
          [2836, 5715],
          [2468, 5585],
          [2182, 5628],
          [2078, 6057],
          [2312, 6091],
          [2571, 6044],
          [2766, 5977],
          [2924, 6084],
          [2974, 6264],
          [3158, 6438],
          [3107, 6712],
          [2981, 6739],
          [2848, 6632],
          [2728, 6766],
          [2723, 6952],
          [3143, 6885],
          [3491, 6971],
          [3634, 6711],
          [3695, 5888],
          [3618, 5363]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6689",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.63,
      "hc-middle-y": 0.62,
      "hc-key": "mu-6689",
      "hc-a2": "PL",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "1377436",
      "subregion": "Port Louis",
      "fips": null,
      "postal-code": null,
      "name": "Port Louis city",
      "country": "Mauritius",
      "type-en": "City",
      "region": null,
      "longitude": "57.5038",
      "woe-name": "Port Louis",
      "latitude": "-20.1496",
      "woe-label": null,
      "type": "City"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2723, 6952],
          [2728, 6766],
          [2848, 6632],
          [2981, 6739],
          [3107, 6712],
          [3158, 6438],
          [2974, 6264],
          [2924, 6084],
          [2766, 5977],
          [2571, 6044],
          [2312, 6091],
          [2078, 6057],
          [2049, 6178],
          [2235, 6260],
          [2560, 6596],
          [2619, 6969],
          [2723, 6952]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6692",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.52,
      "hc-middle-y": 0.41,
      "hc-key": "mu-6692",
      "hc-a2": "QB",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "1377444",
      "subregion": "Plaines Wilhems",
      "fips": null,
      "postal-code": null,
      "name": "Quatre Bornes",
      "country": "Mauritius",
      "type-en": "City",
      "region": null,
      "longitude": "57.4801",
      "woe-name": "Quatre Bornes",
      "latitude": "-20.2688",
      "woe-label": null,
      "type": "City"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [1918, 4271],
          [2638, 4424],
          [2950, 3857],
          [1961, 3569],
          [1918, 4271]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6680",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.44,
      "hc-middle-y": 0.41,
      "hc-key": "mu-6680",
      "hc-a2": "RD",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "2346235",
      "subregion": "Rivière du Rempart",
      "fips": null,
      "postal-code": null,
      "name": "Rivière du Rempart",
      "country": "Mauritius",
      "type-en": "District",
      "region": null,
      "longitude": "57.6557",
      "woe-name": "Riviere du Rempart",
      "latitude": "-20.0651",
      "woe-label": "Riviere du Rempart, MU, Mauritius",
      "type": "District"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [5229, 6299],
          [5005, 7274],
          [5312, 7642],
          [4760, 8206],
          [4883, 8487],
          [4842, 8747],
          [4268, 9438],
          [4378, 9502],
          [4462, 9644],
          [4577, 9787],
          [4779, 9851],
          [5080, 9805],
          [5935, 9555],
          [6163, 9436],
          [6260, 9213],
          [6153, 8865],
          [6227, 8673],
          [6362, 8481],
          [6506, 8143],
          [6667, 7853],
          [6716, 7620],
          [6812, 7495],
          [6890, 7479],
          [7115, 7515],
          [7189, 7495],
          [5229, 6299]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6686",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.66,
      "hc-key": "mu-6686",
      "hc-a2": "RN",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": "Black River",
      "woe-id": "2346228",
      "subregion": "Rivière Noire",
      "fips": null,
      "postal-code": null,
      "name": "Rivière Noire",
      "country": "Mauritius",
      "type-en": "District",
      "region": null,
      "longitude": "57.4149",
      "woe-name": "Black River",
      "latitude": "-20.3424",
      "woe-label": "Black River, MU, Mauritius",
      "type": "District"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2078, 6057],
          [2182, 5628],
          [2013, 5333],
          [1970, 5018],
          [1902, 4530],
          [1918, 4271],
          [1961, 3569],
          [1978, 3289],
          [2040, 2942],
          [2187, 2804],
          [2224, 2769],
          [2142, 2639],
          [1876, 2639],
          [1754, 2509],
          [1856, 2097],
          [1979, 1772],
          [1795, 1621],
          [1958, 1404],
          [2326, 1318],
          [2510, 1209],
          [2490, 906],
          [2265, 1036],
          [1857, 906],
          [1469, 754],
          [1020, 407],
          [673, 299],
          [673, -113],
          [877, -308],
          [823, -609],
          [421, -792],
          [-673, 192],
          [-915, 473],
          [-999, 742],
          [-697, 860],
          [-227, 764],
          [33, 813],
          [147, 1075],
          [246, 1641],
          [224, 1848],
          [16, 1964],
          [169, 2457],
          [187, 3570],
          [274, 4180],
          [404, 4532],
          [836, 5389],
          [994, 5557],
          [1033, 5619],
          [1454, 5971],
          [1637, 6059],
          [2049, 6178],
          [2078, 6057]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6685",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.50,
      "hc-middle-y": 0.50,
      "hc-key": "mu-6685",
      "hc-a2": "SA",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "2346236",
      "subregion": "Savanne",
      "fips": null,
      "postal-code": null,
      "name": "Savanne",
      "country": "Mauritius",
      "type-en": "District",
      "region": null,
      "longitude": "57.5211",
      "woe-name": "Savanne",
      "latitude": "-20.464",
      "woe-label": "Savanne, MU, Mauritius",
      "type": "District"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [3613, 1318],
          [4144, 1339],
          [4532, 1253],
          [4879, 862],
          [5123, 191],
          [5184, -264],
          [5227, -489],
          [4418, -746],
          [2806, -999],
          [2237, -953],
          [1349, -668],
          [823, -609],
          [877, -308],
          [673, -113],
          [673, 299],
          [1020, 407],
          [1469, 754],
          [1857, 906],
          [2265, 1036],
          [2490, 906],
          [2796, 863],
          [2918, 1274],
          [2959, 1448],
          [3245, 1404],
          [3409, 1274],
          [3613, 1318]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6693",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.46,
      "hc-middle-y": 0.48,
      "hc-key": "mu-6693",
      "hc-a2": "VP",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "1377510",
      "subregion": "Plaines Wilhems",
      "fips": null,
      "postal-code": null,
      "name": "Vacoas-Phoenix",
      "country": "Mauritius",
      "type-en": "City",
      "region": null,
      "longitude": "57.4908",
      "woe-name": "Vacoas",
      "latitude": "-20.3024",
      "woe-label": null,
      "type": "City"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [2416, 2940],
          [2187, 2804],
          [2040, 2942],
          [1978, 3289],
          [1961, 3569],
          [2950, 3857],
          [3285, 3455],
          [2416, 2940]
        ]
      ]
    }
  }, {
    "type": "Feature",
    "id": "MU.6681",
    "properties": {
      "hc-group": "admin1",
      "hc-middle-x": 0.58,
      "hc-middle-y": 0.51,
      "hc-key": "mu-6681",
      "hc-a2": "FL",
      "labelrank": "20",
      "hasc": "MU.",
      "alt-name": null,
      "woe-id": "2346229",
      "subregion": "Flacq",
      "fips": null,
      "postal-code": null,
      "name": "Flacq",
      "country": "Mauritius",
      "type-en": "District",
      "region": null,
      "longitude": "57.7206",
      "woe-name": "Flacq",
      "latitude": "-20.2173",
      "woe-label": "Flacq, MU, Mauritius",
      "type": "District"
    },
    "geometry": {
      "type": "Polygon",
      "coordinates": [
        [
          [7189, 7495],
          [7401, 7314],
          [7457, 7184],
          [7394, 6533],
          [7541, 6322],
          [7738, 6165],
          [7920, 5590],
          [8285, 5153],
          [8368, 4939],
          [8333, 4455],
          [8236, 3902],
          [8031, 3285],
          [7618, 3329],
          [7066, 2897],
          [6330, 2832],
          [5942, 2811],
          [6147, 3569],
          [5208, 4350],
          [5821, 4956],
          [5168, 5454],
          [4779, 5628],
          [4792, 5707],
          [4820, 5888],
          [5147, 6104],
          [5229, 6299],
          [7189, 7495]
        ]
      ]
    }
  }]
};

export default mauritius;
